/**
 * This setup global places in a trie tree
 * 
 **/
 

import {
    Injectable
} from '@angular/core';


import {
    Place_Item,
} from '../interfaces';

import {
    SERVICE,   
} from './NeurConstants';

import {Storage} from '@ionic/storage';

interface TrieNode {
    children: Map < string, TrieNode > ;
    isEndOfWord: boolean;
    data: Place_Item[];
}

@Injectable()

class GlobalPlaceInfoService {
    private trie: TrieNode | null = null;

    private countryTrie: TrieNode | null = null;

    private countries: any[] = [];

    constructor( private storage:Storage) {}
    
    public async setAllCountriesInfo (items: Place_Item[], _noneEnglish: boolean){
        this.countries = items;
        this.countries.sort((a, b) => a.name[0].localeCompare(b.name[0]));

        const root: TrieNode = {
            children: new Map(),
            isEndOfWord: false,
            data: []
        };
        
        for (const item of items) {
            item.displayName = item.name;
            let node = root;
            for (const char of item.name[0].toLowerCase()) {
                if (!node.children.has(char)) {
                    node.children.set(char, {
                        children: new Map(),
                        isEndOfWord: false,
                        data: []
                    });
                }
                node = node.children.get(char) !;
            }
            node.isEndOfWord = true;
            node.data.push(item);
            
            let englishNodeData = node.data;
            
            if (_noneEnglish) {
                let node = root;
                for (const char of item.name[1].toLowerCase()) {
                    if (!node.children.has(char)) {
                        node.children.set(char, {
                            children: new Map(),
                            isEndOfWord: false,
                            data: []
                        });
                    }
                    node = node.children.get(char) !;
                }
                node.isEndOfWord = true;
                node.data = englishNodeData; 
            }
        }
        this.countryTrie = root;
        await this.storage.set(SERVICE.WORLD_COUNTRIES_STORAGE,root);   
        await this.storage.set(SERVICE.WORLD_COUNTRY_LIST_STORAGE,this.countries);
    }

    public async setAllPlacesInfo (items: Place_Item[], _noneEnglish: boolean) {
        const root: TrieNode = {
            children: new Map(),
            isEndOfWord: false,
            data: []
        };
        //this.countries = [];
        const placeMap: Map<string, Place_Item[]> = new Map();
        
        for (const item of items) {
            
            if (item.hasOwnProperty('country')) {
                if (item.country.hasOwnProperty('name')){
                    item.displayName = item.name.map((n, i) => n + ', '+ item.country.name[i]);
/*
                    let countryInfo  = this.getCountryInfo(item.country.name[1]);
                    if (countryInfo) { // not neeeded if server bug fixed
                        item.country.flagClass = countryInfo.country.flagClass;
                    }
*/                      

                    if (item.hasOwnProperty('state_province')){ //a city /town
                        item.icon = '\u{1F306}';
                    }
                    else { // a state/province
                        if (item.country.name[1]=='United Kingdom'){
                            switch (item.name[1]) {
                                case 'England':
                                    item.icon = '\u{1F3F4}\u{E0067}\u{E0062}\u{E0065}\u{E006E}\u{E0067}\u{E007F}';
                                    break;
                                case 'Scotland':
                                    item.icon = '\u{1F3F4}\u{E0067}\u{E0062}\u{E0073}\u{E0063}\u{E0074}\u{E007F}';
                                    break;
                                case 'Wales':
                                    item.icon = '\u{1F3F4}\u{E0067}\u{E0062}\u{E0077}\u{E006C}\u{E0073}\u{E007F}';
                                    break;
                                default:
                                    item.icon = '\u{1F3DE}'
                                    break;
                            }
                        }
                        else {
                            //item.icon = '\u{1F3DE}';
                            item.icon = '\u{1F3F3}\u{FE0F}';
                        }
                    }
                }
                else {// a country
                    item.displayName = item.name;
                    item.icon = item.country.flagClass;
                }
            }
            else if (item.hasOwnProperty('continent')){
                item.displayName = item.name.map((n, i) => n + ', '+ item.continent[i]);
                if (item.name[1] == 'Indian Ocean'){
                    item.icon = '\u{1F334}';
                }
                else if (item.name[1] == 'Caribbean'){
                    item.icon = '\u{1F3D6}\u{FE0F}';
                }
            }
            else { //a continent 
                item.displayName = item.name;
                if (['Europe','Africa','Middle East'].includes(item.name[1])){
                    item.icon = '\u{1F30D}';
                }
                else if (['Asia','South Pacific','Antarctic'].includes(item.name[1])){
                    item.icon = '\u{1F30F}';
                }
                else if (['North America','South America','Central America'].includes(item.name[1])){
                    item.icon = '\u{1F30E}';
                }

            }
        
            let node = root;
            for (const char of item.name[0].toLowerCase()) {
                if (!node.children.has(char)) {
                    node.children.set(char, {
                        children: new Map(),
                        isEndOfWord: false,
                        data: []
                    });
                }
                node = node.children.get(char) !;
            }
            node.isEndOfWord = true;
            if (node.data.length >= 1) { //has duplicated name with this item, need to change displayName for this item
                node.data.forEach((place)=> {
                    if (place.hasOwnProperty('country') && place.country.hasOwnProperty('name') && item.hasOwnProperty('country') && item.country.hasOwnProperty('name') ){
                           if (place.country.name[1] == item.country.name[1]){
                                if (place.hasOwnProperty('state_province') ) {
                                        place.displayName = place.name.map((n, i) => n + ', ' + place.state_province[i]+', '+ place.country.name[i]);
                                }    
                                if (item.hasOwnProperty('state_province')){
                                        item.displayName = item.name.map((n, i) => n + ', ' + item.state_province[i]+', '+ item.country.name[i]);
                                }
                           }
                    }
                });
            }
            node.data.push(item);
            let englishNodeData = node.data;

            if (_noneEnglish) {
                let node = root;
                for (const char of item.name[1].toLowerCase()) {
                    if (!node.children.has(char)) {
                        node.children.set(char, {
                            children: new Map(),
                            isEndOfWord: false,
                            data: []
                        });
                    }
                    node = node.children.get(char) !;
                }
                node.isEndOfWord = true;
                node.data = englishNodeData; 
            }
        }
        this.trie = root;
        await this.storage.set(SERVICE.WORLD_PLACES_STORAGE,root);      
    }

    findPlacesWithPrefix(prefix: string, limit: number): Place_Item[] {
        if (!this.trie) {
            return [];
        }
        //console.log("trie exist");
        let node = this.trie;

        for (const char of prefix.toLowerCase()) {
            if (!node.children.has(char)) {
                //console.log("children has no char");
                return [];
            }
            node = node.children.get(char) !;
        }
        const results: Place_Item[] = [];
        this.collectResults(node, prefix, results, limit);
        return results;
    }
    
    private collectResults(node: TrieNode, prefix: string, results: Place_Item[], limit: number): void {
        if (results.length >= limit) {
            return;
        }
        if (node.isEndOfWord) {
            results.push(...node.data);
        }
        for (const [char, child] of node.children) {
            if (results.length >= limit) {
                break;
            }
            this.collectResults(child, prefix + char, results, limit);
        }
    }
    
    findPlaceByName(name: string): Place_Item[] {
        if (!this.trie){
            return [];
        }
        
        let node = this.trie;

        for (const char of name.toLowerCase()) {
            if (!node.children.has(char)) {
                return []; // Place not found
            }
            node = node.children.get(char)!;
        }

        return node.data;
    }

    getAllCountriesInfo(): Place_Item[] {
        return this.countries;
    }
    
    
    public async retreiveAllCountriesInfo(){
        let countryRoot = await this.storage.get(SERVICE.WORLD_COUNTRIES_STORAGE);
        if (countryRoot){
            this.countryTrie = countryRoot; 
        }
        
        this.countries = await this.storage.get(SERVICE.WORLD_COUNTRY_LIST_STORAGE);
    }


    public async retreiveAllPlacesInfo(){
        let places = await this.storage.get(SERVICE.WORLD_PLACES_STORAGE);
        if (places){
            this.trie = places;
        }
    }
    
    getCountryInfo(name: string):Place_Item {
        if (!this.countryTrie){
            return null;
        }
        
        let node = this.countryTrie;

        for (const char of name.toLowerCase()) {
            if (!node.children.has(char)) {
                return null; // Place not found
            }
            node = node.children.get(char)!;
        }

        return node.data[0]; //assumed country names are unique
        
    }

}

/*
    Service class should be exported as ExportedClass
*/
export {
    GlobalPlaceInfoService as ExportedClass
};